import { Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { catchError, retry } from 'rxjs/operators';
import { InformacaoVO } from 'src/app/entity/InformacaoVO';
import { URL_API } from 'src/app/tools/URL';
import { ATUALIZAR, CARREGAR, ENVIAR, ErrorsService, SALVAR } from '../errors/errors.service';
import { RestService } from '../rest.service';
import { AuthService } from '../autenticacao/auth.service';

@Injectable({
  providedIn: 'root'
})
export class InformacaoService {

  informacao = this.builder.group(this.preencherVo());

  constructor(
    private rest: RestService,
    private builder: FormBuilder,
    private errorsService: ErrorsService,
    private authService: AuthService) { }

  carregarDados() {
    return this.rest.get(`${URL_API.PATH_INFORMACAO}/carregar`).pipe(
      retry(1),
      catchError(response => this.errorsService.handleError(response, CARREGAR))
    );
  }

  carregarDadosService() {

    this.carregarDados().subscribe(retorno => {
      this.informacao.controls.listaClassificacaoCompleta.setValue(retorno.listaClassificacaoCompleta);
      this.informacao.controls.listaCartorio.setValue(retorno.listaCartorio);
      this.informacao.controls.assuntos.setValue(retorno.assuntos);
    });

  }

  carregarPorId(id: number) {

    return this.rest.get(`${URL_API.PATH_INFORMACAO + '/' + id}`);

  }

  gravarManifestoOperador(manifestante, arquivos = [], isEnviar) {

    this.informacao.controls.nome.setValue(manifestante.nome);
    this.informacao.controls.email.setValue(manifestante.email);
    this.informacao.controls.username.setValue(this.authService.usuarioLogado.username);

    this.informacao.controls.files.setValue([]);
    arquivos.forEach((value, key) => {
      this.informacao.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });

    return isEnviar ? this.enviar(this.informacao.getRawValue()) : this.salvar(this.informacao.getRawValue());

  }

  salvar(obj) {
    if (obj.id == null) {
      return this.gravar(obj);
    } else {
      return this.atualizar(obj);
    }
  }

  public enviar(obj: InformacaoVO) {
    return this.rest.post(`${URL_API.PATH_INFORMACAO}/enviar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ENVIAR))
    );
  }

  private gravar(obj: InformacaoVO) {
    return this.rest.post(`${URL_API.PATH_INFORMACAO}/salvar`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, SALVAR))
    );
  }

  private atualizar(obj) {
    return this.rest.put(`${URL_API.PATH_INFORMACAO}/salvar/${obj.id}`, obj).pipe(
      catchError(response => this.errorsService.handleError(response, ATUALIZAR))
    );
  }

  buscarProcesso() {

    const numeroProcesso = this.informacao.value.numeroProcesso.replace('-', '').split('.').join('');

    return this.rest.get(`${URL_API.PATH_INFORMACAO}/processo/buscar`, {
      numeroProcesso,
      tipoJustica: this.informacao.value.tipoDeJustica.toString()
    });

  }

  preencherVo() {
    return {
      id: null,
      files: null,
      username: new FormControl(null),
      dataHoraAbertura: null,
      nome: new FormControl(null),
      email: new FormControl(null),
      assunto: new FormControl(null, [Validators.required]),
      descricaoInformacao: new FormControl(null, [Validators.required]),
      listaClassificacao: new FormControl([], [Validators.required]),
      listaClassificacaoCompleta: [],
      assuntos: [],
      tipoDeJustica: new FormControl(null),
      numeroProcesso: new FormControl({ value: null, disabled: true }),
      comarca: new FormControl({ value: null, disabled: true }),
      vara: new FormControl({ value: null, disabled: true }),

      listaCartorio: [],
      municipio: new FormControl({ value: null, disabled: false }),
      cartorio: new FormControl({ value: null, disabled: true }),
      localidade: new FormControl({ value: null, disabled: true }),

      demandaRecebida: new FormControl(null)

    } as InformacaoVO;
  }
}
